import { FC, useEffect, useState } from "react";
import { Form, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  getProcedureAmountNew,
  getStratsDataNew,
} from "../../../../apis/patientService";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import { rejectJfifUpload } from "../../../../utils/fileUploadValidation";
import { fetchProcedureNew } from "../../../../models/preAuthClaimSlice";
import {
  fetchEnhancementProcedureCghsNew,
  fetchResubmissionDataServiceCghsNew,
  getResubmissionReason,
  saveResubmissionData,
} from "../../../../apis/SchemeService/CGHS/cghsService";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import dayjs from "dayjs";
import ResubmissionCompareModalCghsNew from "../../../../components/patient/Resubmission/CGHSNEW/ResubmissionCompareModalCghsNew";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import { getGovtBillList } from "../../../../apis/govtBillingService";
import { GovtBillFetchRequest } from "../../../../models/billsSlice";
import { fetchStepperData } from "../../../../models/preAuthSlice";

interface ResubmissionProcedureForCghsContainerProps {
  resubmissionCghs: boolean;
  closeResubmissionCghsModal: any;
  activeKey: any; // Define prop type for the function
}

const ResubmissionContainerCghsNew: FC<
  ResubmissionProcedureForCghsContainerProps
> = (props) => {
  const [form] = Form.useForm();
  const [reasonOfResubmissionForm] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuthClaim, auth, enhancement } = useSelector(
    (state: RootState) => state,
  );
  const [resubmissionProcedure, setResubmissionProcedure] = useState<any>([]);
  const [procedureStrats, setProcedureStrats] = useState({}); //to store strats of procedure
  const [deleteProcedureList, setDeleteProcedureList] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false); //to open modal for confirmation of deletion of the procedure
  const [isFetchingProcedures, setIsFetchingProcedures] =
    useState<boolean>(false);
  const [procedureForm] = Form.useForm();
  const [resubmissionReasonOptions, setResubmissionReasonOptions] =
    useState<any>([]);
  const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState<
    {
      documentUrl: string;
      documentType: string;
      documentLabelType: string;
      documentName: string;
      deficiencyCheckStatus: any;
      id: number;
    }[]
  >([]);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [hospitalBills, setHospitalBills] = useState<
    { fileUrl: string; fileName: string; id?: number }[]
  >([]);

  const extractHospitalBillsFromBillAudit = (allDocumentList: any) => {
    const billAuditDocs = allDocumentList?.["Bill Audit"] || [];
    const hospitalBillEntry = billAuditDocs?.find(
      (item: any) =>
        item?.label?.toUpperCase() === "HOSPITAL BILL" ||
        item?.documentLabelType?.toUpperCase() === "HOSPITAL BILL",
    );

    const docs = hospitalBillEntry?.documentList || [];
    const uniqueByUrl = new Map<string, { fileUrl: string; fileName: string; id?: number }>();

    docs.forEach((doc: any, index: number) => {
      const fileUrl = doc?.documentUrl;
      if (!fileUrl) return;
      if (uniqueByUrl.has(fileUrl)) return;
      uniqueByUrl.set(fileUrl, {
        fileUrl,
        fileName:
          doc?.documentName ||
          doc?.documentLabelType ||
          `Hospital Bill ${index + 1}`,
        id: doc?.id,
      });
    });

    return Array.from(uniqueByUrl.values());
  };

  const fetchDocuments = async (
    schemeMetaDataId: number,
    caseId: number,
    visitId: number,
  ) => {
    try {
      // const documentList = await getDocuments(props?.schemeMetaDataId);
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId,
        );
        setDocumentTypes(AllDocumentList?.["Resubmission"]);
        setHospitalBills(extractHospitalBillsFromBillAudit(AllDocumentList));
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setHospitalBills([]);
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
        patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName &&
        patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        dispatch(
          fetchProcedureNew({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS NEW"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
              benType: patients?.fetchBasicDetails?.patientResponse?.cardCategory ? patients?.fetchBasicDetails?.patientResponse?.cardCategory?.toLowerCase()?.includes("Gen"?.toLowerCase()) ? "DGW" : patients?.fetchBasicDetails?.patientResponse?.cardCategory?.toLowerCase()?.includes("Private"?.toLowerCase()) ? "DPW" : "DSPW" : null
          }),
        );
      }
      fetchDocuments(
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
    props?.resubmissionCghs,
  ]);

  useEffect(() => {
      if (
        resubmissionProcedure &&
        resubmissionProcedure.length > 0
      ) {
        procedureForm.setFieldsValue({
          items: resubmissionProcedure,
        });
      }
    }, [resubmissionProcedure, procedureForm]);

  const formattedAccreditationOptions: Array<{ label: string; value: string }> =
    [
      { label: "NABH", value: "NABH" },
      { label: "NABL", value: "NABL" },
      { label: "NON NABL", value: "NON NABL" },
      { label: "NON NABH", value: "NON NABH" },
    ]?.map((option) => ({
      value: option?.value + "~" + option?.label,
      label: option.label,
    }));
  const formattedTreatingDoctorsOptions: Array<{
    label: string;
    value: string;
  }> = [{ treatingDoctorCode: "OTHERS", treatingDoctorName: "OTHERS" }]?.map(
    (option) => ({
      value: option?.treatingDoctorCode + "~" + option?.treatingDoctorName,
      label: option?.treatingDoctorName,
    }),
  );
  const formattedProcedureReferral: Array<{ label: string; value: string }> = [
    { label: "REFERRAL", value: "referral" },
    { label: "NON REFERRAL", value: "non referral" },
  ]?.map((option) => ({
    value: option?.value + "~" + option?.label,
    label: option.label,
  }));
  const formattedProceduresOptions: Array<{ label: string; value: string }> =
    preAuthClaim?.procedureDropDown
      ? preAuthClaim?.procedureDropDown?.map((option: any) => ({
          value: JSON.stringify(option),
          label: option?.procedureName,
          extra: {
            amount: option?.amount
          },
        }))
      : [];

  const handleGetProcedureAmount = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW"
            ? true
            : false,
      };
      const procedureAmountRes = await getProcedureAmountNew(newFormData);
      return procedureAmountRes;
    } catch (err: any) {
      // errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleGetProcedureStrats = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS NEW"
            ? true
            : false,
      };
      const procedureStrats = await getStratsDataNew(newFormData);
      setProcedureStrats((prevStrats) => ({
        ...prevStrats,
        [formData.procedureId]: procedureStrats,
      }));
      return procedureStrats;
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handleFetchProcedureList = async () => {
    try {
      setIsFetchingProcedures(true);
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const res = await fetchEnhancementProcedureCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        );
        setResubmissionProcedure(res);
        setIsFetchingProcedures(false);
      }
    } catch (err: any) {
      setIsFetchingProcedures(false);
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleDeleteProcedure = async (procedure: any) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        setDeleteProcedureList((prevList) => [...prevList, procedure]);
        successMessage("Procedure added in archieve list");
        return true;
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
      return false;
    }
  };

  const fetchStepperForStatus = async () => {
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
        const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
        dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
      }
    };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  };

  const handleSubmitResubmissionProcedure = async (
    values: any,
    reasonOfResubmissionFormValues: any,
  ) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const requestPayload = {
          reSubmissionProcedures: values?.length > 0 ? values : [],
          deletedProcedures: deleteProcedureList,
          reason: reasonOfResubmissionFormValues?.resubmissionReason,
          remarks: reasonOfResubmissionFormValues?.remarks,
          documentUrls: uploadedDocumentUrl || [],
        };

        await saveResubmissionData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          requestPayload,
        );

        props?.closeResubmissionCghsModal();
        setUploadedDocumentUrl([]);
        setResubmissionProcedure([]);
        setDeleteProcedureList([]);
        form.resetFields();
        reasonOfResubmissionForm.resetFields();
        await fetchStepperForStatus();
        await getTimelineDetail();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleOk = (procedure: any) => {
    handleDeleteProcedure(procedure);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFileChange = (documentType: string) => (e: any) => {
    if (rejectJfifUpload(e)) return;
    if (Array.isArray(e)) {
      return e;
    }
    if (e?.file) {
      setSelectedFile({ file: e.file, documentType: documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setPreviewModalVisible(true);
    }
    return e?.target?.files;
  };
  const handleUpload = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);
    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }
    try {
      const documentRes = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        }),
      ).unwrap();
      // const updatedDocuments = updateOrAddDocument(
      //   uploadedDocumentUrl,
      //   documentRes
      // );

      const updatedDocuments = [...uploadedDocumentUrl, ...documentRes];
      setUploadedDocumentUrl(updatedDocuments);
      setPreviewModalVisible(false);
      message.success(
        `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
      );
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
    } catch (err: any) {
      errorMessage("Please, Try again later");
    }
  };
  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number,
  ) => {
    const deleteDocument = uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl,
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl,
    );
    setUploadedDocumentUrl(newUpdatedDocumentList);
    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
        message.success("Document Deleted Successfully");
      } catch (err) {
        console.error(err);
      }
    }
  };
  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any,
  ) => {
    try {
      if (selectedDocument?.id) {
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocument?.id),
        );
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };
  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields,
  ) => {
    await fetchDeficiencyData(document, documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };
  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };
  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const procedureValues = await procedureForm.validateFields();
      let reasonOfResubmissionFormValues;

      try {
        reasonOfResubmissionFormValues =
          await reasonOfResubmissionForm.validateFields();
      } catch (err: any) {
        errorMessage("Please select Resubmission Reason and enter Remarks");
        return;
      }

      const procedureFormUpdatedValues =  procedureValues?.items?.length > 0 ? procedureValues?.items?.map((value: any) => {
        let result: any = {
          ...value,
          procedureReferral: value?.procedureReferral?.split("~")?.[0],
          procedureReferralName: value?.procedureReferral?.split("~")?.[1],
          accreditationStatus: value?.accreditationStatus?.split("~")?.[0],
          accreditationStatusName: value?.accreditationStatus?.split("~")?.[1],
          treatingDoctorCode: value?.treatingDoctor?.split("~")?.[0],
          treatingDoctor: value?.treatingDoctor?.split("~")?.[1],
          treatmentStartDate: value?.treatmentStartDate
            ? value?.treatmentStartDate
            : null,
          ...JSON.parse(value?.procedureCode),
          stratsId: JSON.parse(value?.procedureCode)?.id,
          procedureAmount: value?.procedureAmount,
          status: true,
          casePreAuthProceduresId: value?.casePreAuthCghsProceduresId ?? null,
          documentUrls: uploadedDocumentUrl || [],
        };
        if (value?.stratOptionValue) {
          result = { ...result, ...JSON.parse(value.stratOptionValue) };
        }
        delete result?.["id"];
        delete result?.["casePreAuthCghsProceduresId"];
        return result;
      }) : [];

      const updatedValues = values?.items?.length > 0 ? values?.items?.map((value: any) => {
        let result: any = {
          ...value,
          procedureReferral: value?.procedureReferral?.split("~")?.[0],
          procedureReferralName: value?.procedureReferral?.split("~")?.[1],
          accreditationStatus: value?.accreditationStatus?.split("~")?.[0],
          accreditationStatusName: value?.accreditationStatus?.split("~")?.[1],
          treatingDoctorCode: value?.treatingDoctor?.split("~")?.[0],
          treatingDoctor: value?.treatingDoctor?.split("~")?.[1],
          treatmentStartDate: value?.treatmentStartDate
            ? dayjs(value?.treatmentStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          ...JSON.parse(value?.procedureCode),
          stratsId: JSON.parse(value?.procedureCode)?.id,
          procedureAmount: value?.procedureAmount,
          status: true,
          casePreAuthProceduresId: value?.casePreAuthCghsProceduresId ?? null,
          documentUrls: uploadedDocumentUrl || [],
        };
        if (value?.stratOptionValue) {
          result = { ...result, ...JSON.parse(value.stratOptionValue) };
        }
        delete result?.["id"];
        delete result?.["casePreAuthCghsProceduresId"];
        return result;
      }) : [];

      setIsSubmitting(true);
      await handleSubmitResubmissionProcedure(
        [...procedureFormUpdatedValues, ...updatedValues],
        reasonOfResubmissionFormValues,
      );
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please fill all details before submitting");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGetResubmissionReason = async () => {
    try {
      const res = await getResubmissionReason();
      const formattedOptions = res?.map((option: any) => ({
        value: option,
        label: option,
      }));

      setResubmissionReasonOptions(formattedOptions);
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  useEffect(() => {
    if (props?.resubmissionCghs) {
      // handleFetchProcedureList();
      fetchResubmissionData();
      handleGetResubmissionReason();
    }
  }, [props?.resubmissionCghs]);

  const fetchResubmissionData = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        setIsFetchingBillDetails(true);
        const res: any = await fetchResubmissionDataServiceCghsNew(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
        );
        if (!Array.isArray(res) || res.length === 0) {
          fetchHospitalBillList();
        } else {
          handleFetchProcedureList();
        }
      }
    } catch (error: any) {
      // errorMessage(error.message || "Please, Try again later");
    } finally {
      setIsFetchingBillDetails(false);
    }
  };

  // useEffect(() => {
  //   if (props?.resubmissionCghs) {
  //     fetchResubmissionData();
  //   }
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.id,
  //   patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //   patients?.fetchBasicDetails?.casesResponse?.healthCareId,
  //   props?.resubmissionCghs,
  // ]);

  const [billItemsList, setBillItemsList] = useState<any[]>([]);
  const [govtBillMappingId, setGovtBillMappingId] = useState<number | null>(
    null,
  );
  const [isFetchingBillDetails, setIsFetchingBillDetails] =
    useState<boolean>(false);

  useEffect(() => {
    fetchGovtBill();
  }, [govtBillMappingId]);

  const fetchHospitalBillList = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        const filters = {
          pageNumber: 1,
          pageSize: 10,
          searchTer: "",
        };
        setIsFetchingBillDetails(true);
        const response = await getGovtBillList(
          patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          filters,
        );

        setGovtBillMappingId(
          response?.data?.billMappingResponseList?.length
            ? response.data.billMappingResponseList?.[0].id
            : null,
        );
      }
    } catch (err) {
    } finally {
      setIsFetchingBillDetails(false);
    }
  };

  const fetchGovtBill = async () => {
    try {
      if (
        !patients?.fetchBasicDetails?.casesResponse?.healthCareId ||
        !govtBillMappingId
      )
        return;
      setIsFetchingBillDetails(true);
      const response = await dispatch(
        GovtBillFetchRequest({
          healthCareId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          govtBillMappingId: govtBillMappingId,
        }),
      );
      setIsFetchingBillDetails(false);
      setBillItemsList(response?.payload?.data?.billItemsResponseList || []);
    } catch (error) {
      console.error("Error in fetching bill:", error);
    } finally {
      setIsFetchingBillDetails(false);
    }
  };

  const [mappedProcedures, setMappedProcedures] = useState<any[]>([]);

  useEffect(() => {
    if (
      billItemsList &&
      billItemsList?.length > 0 &&
      preAuthClaim?.procedureDropDown &&
      preAuthClaim?.procedureDropDown?.length > 0
    ) {
      const autoMappedProcedures = mapBillItemsWithProcedures(
        billItemsList || [],
        preAuthClaim?.procedureDropDown || [],
      );

      setMappedProcedures(autoMappedProcedures);
    }
  }, [billItemsList, preAuthClaim?.procedureDropDown]);

  useEffect(() => {
    if (!mappedProcedures?.length) return;
    const items = mappedProcedures?.map((item: any) => ({
      numberOfDays: item?.numberOfDays ?? null,
      externalProcedureCode: item?.externalProcedureCode ?? null,
      strats: item?.strats ?? null,
      // admissibleRate: item?.admissibleRate ?? null,
      procedureAmount: item?.procedureAmount ?? null,
      totalIntimatedAmount:
        item?.procedureAmount && item?.numberOfDays
          ? parseFloat(item?.procedureAmount) * parseFloat(item?.numberOfDays)
          : null,
      procedureTotalAmount:
        item?.procedureAmount && item?.numberOfDays
          ? parseFloat(item?.procedureAmount) * parseFloat(item?.numberOfDays)
          : null,
      // hospitalRemark: item?.hospitalRemark ?? null,
      treatmentStartDate: patients?.fetchBasicDetails?.visitInfoResponse?.doa
        ? dayjs(
            patients?.fetchBasicDetails?.visitInfoResponse?.doa,
            "DD-MM-YYYY HH:mm:ss",
          )
        : null,
      accreditationStatus: patients?.fetchBasicDetails?.casesResponse
        ?.nablStatus
        ? "NABL~NABL"
        : patients?.fetchBasicDetails?.casesResponse?.nabhStatus
          ? "NABH~NABH"
          : "NON NABH~NON NABH",
      treatingDoctor: "OTHERS~OTHERS",
      procedureReferral: "referral~REFERRAL",
      id: null,
      referralServiceName: item?.referralServiceName ?? null,
      pid: item?.pid,
      stratsId: item?.stratsId,
      // procedureCode: item?.procedureName
      //   ? JSON.stringify({
      //       procedureCode: item?.procedureCode,
      //       procedureName: item?.procedureName,
      //       procedureType: item?.procedureType,
      //       externalProcedureCode: item?.externalProcedureCode,
      //       strats: item?.strats,
      //       id: Number(item?.id) || Number(item?.stratsId) || null,
      //       nablStatus: item?.nablStatus || null,
      //       casePreAuthCghsProceduresId: item?.casePreAuthCghsProceduresId || null,
      //       procedureAmount: null,
      //       referralServiceName: null
      //     })
      //   : null,
      procedureCode: item?.procedureName ? item?.matchedProcedure : null,
    }));
    form.setFieldsValue({ items: items?.length > 0 ? items : null });
  }, [mappedProcedures]);

  function mapBillItemsWithProcedures(billItems: any, procedures: any) {
    if (!Array.isArray(billItems) || !Array.isArray(procedures)) {
      return [];
    }

    const groupedByCode = new Map();

    billItems
      ?.filter((item: any) => item.schemeCode && item.schemeCode.trim() !== "")
      ?.forEach((item: any) => {
        const matchedProcedure = procedures?.find(
          (proc: any) => proc.externalProcedureCode === item.schemeCode,
        );

        if (!matchedProcedure) return;

        const key = matchedProcedure?.externalProcedureCode || item.schemeCode;
        const serviceQty = Number(item.serviceQty || 0);
        const serviceRate = Number(item.serviceSchemeRate || 0);

        if (!groupedByCode.has(key)) {
          groupedByCode.set(key, {
            matchedProcedure,
            totalQty: 0,
            serviceRate,
            serviceName: item?.serviceName,
          });
        }

        const group = groupedByCode.get(key);
        group.totalQty += serviceQty;
        group.serviceRate = group.serviceRate || serviceRate;
      });

    const mappedProcedures: any[] = [];

    groupedByCode.forEach(({ matchedProcedure, totalQty, serviceRate, serviceName }: any) => {
      const allowedQty = Number(
        matchedProcedure?.qtyAllowed ??
          matchedProcedure?.allowedQty ??
          matchedProcedure?.quantityAllowed ??
          0,
      );

      let remainingQty = totalQty;

      while (remainingQty > 0) {
        const chunkQty = allowedQty > 0 ? Math.min(remainingQty, allowedQty) : remainingQty;

        mappedProcedures.push({
          id: null,
          nablStatus: matchedProcedure.nablStatus,
          externalProcedureCode: matchedProcedure.externalProcedureCode,
          procedureCode: matchedProcedure.procedureCode,
          procedureName: matchedProcedure.procedureName,
          procedureType: matchedProcedure.procedureType ?? null,
          numberOfDays: String(chunkQty),
          procedureAmount: String(serviceRate),
          totalIntimatedAmount: String(chunkQty * serviceRate),
          referralServiceName: serviceName,
          strats: matchedProcedure?.strats,
          stratsId: matchedProcedure?.id,
          matchedProcedure: JSON.stringify(matchedProcedure),
          specialityType: matchedProcedure?.specialityType,
        });

        remainingQty = remainingQty - chunkQty;
      }
    });

    return mappedProcedures;
  }

  return (
    <div style={{ padding: "14px" }} className="Deepak">
      <ResubmissionCompareModalCghsNew
        addNewResubmissionModal={props?.resubmissionCghs}
        closeCreateResubmissionModal={props?.closeResubmissionCghsModal}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        isFetchingPortalData={isFetchingProcedures}
        resubmissionProcedure={resubmissionProcedure}
        formattedAccreditationOptions={formattedAccreditationOptions}
        formattedTreatingDoctorsOptions={formattedTreatingDoctorsOptions}
        formattedProcedureReferral={formattedProcedureReferral}
        formattedProceduresOptions={formattedProceduresOptions}
        handleGetProcedureAmount={handleGetProcedureAmount}
        handleGetProcedureStrats={handleGetProcedureStrats}
        patientDetails={patients?.fetchBasicDetails}
        procedureStrats={procedureStrats}
        handleDeleteProcedure={handleDeleteProcedure}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleOk={handleOk}
        form={form}
        resubmissionReasonOptions={resubmissionReasonOptions}
        reasonOfResubmissionForm={reasonOfResubmissionForm}
        documentTypes={documentTypes}
        documentUrls={uploadedDocumentUrl}
        handleFileChange={handleFileChange}
        handleOpen={handleOpen}
        isFetchingBillDetails={isFetchingBillDetails}
        isSubmitting={isSubmitting}
        procedureForm={procedureForm}
        hospitalBills={hospitalBills}
      />
      <FilePreviewModal
        isVisible={previewModalVisible}
        onClose={() => setPreviewModalVisible(false)}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUpload}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.lastModified || "no-file"}
        isLoading={enhancement?.isLoading}
      />

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={uploadedDocumentUrl}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setUploadedDocumentUrl}
        activeKey={props?.activeKey}
        clickedActiveTab={clickedActiveTab}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
      />
    </div>
  );
};
export default ResubmissionContainerCghsNew;
